import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimePieChartComponent } from './time-pie-chart.component';
import {DxChartModule, DxPieChartModule} from 'devextreme-angular';



@NgModule({
  declarations: [TimePieChartComponent],
    imports: [
        CommonModule,
        DxPieChartModule,
        DxChartModule
    ],
  exports: [TimePieChartComponent]
})
export class TimePieChartModule { }
